// This is used for inputs, selects and buttons
export enum InputSize {
  xxs = 62,
  xs = 80,
  small = 100,
  medium = 240,
  medlarge = 375,
  large = 500,
}

export enum HeightSize {
  medium = 35,
  mediumLarge = 40,
  large = 50,
}

// Form names
export const CUSTOMS_ITEM_FORM = 'CUSTOMS_ITEM_FORM';
export const CUSTOMS_DECLARATION_FORM = 'CUSTOMS_DECLARATION_FORM';
export const LABELS_DEFAULT_LABEL_FORMAT_FORM_NAME = 'LabelsDefaultForm';
export const LINE_ITEM_FORM = 'LINE_ITEM_FORM';
export const NOTIFICATIONS_FORM_NAME = 'NotificationsForm';
export const ADDITIONAL_INFORMATION_FORM = 'ADDITIONAL_INFORMATION_FORM';
export const WHAT_TYPE_OF_BUSINESS_FORM = 'WHAT_TYPE_OF_BUSINESS';
export const INSTRUCTIONAL_MESSAGES_FORM = 'INSTRUCTIONAL_MESSAGES_FORM';
export const ADDITIONAL_SERVICES_FORM = 'ADDITIONAL_SERVICES_FORM';
export const PARCEL_FORM_NAME = 'ORDER_PARCEL_FORM';
export const COMPANY_FORM = 'company-form';
export const TRACKING_ADS_FORM = 'TRACKING_ADS_FORM';
export const AUTOMATIONS_RULE_FORM = 'AUTOMATIONS_RULE_FORM';
export const REG_SOURCE_FORM = 'REG_SOURCE_FORM';
export const SPLIT_ORDERS_FORM = 'SPLIT_ORDERS_FORM';
export const CUSTOMS_OPT_OUT_FORM = 'CUSTOMS_OPT_OUT_FORM';
export const CARRIER_FORM = 'CARRIER_FORM';
export const ORDER_RECIPIENT_ADDRESS_FORM = 'ORDER_RECIPIENT_ADDRESS_FORM';
export const ORDER_SENDER_RETURN_ADDRESS_FORM = 'ORDER_SENDER_RETURN_ADDRESS_FORM';

export type ExtrasFormType =
  | typeof CUSTOMS_OPT_OUT_FORM
  | typeof ADDITIONAL_SERVICES_FORM
  | typeof ORDER_RECIPIENT_ADDRESS_FORM;
